var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "text-align": "center" }, attrs: { id: "printBarCode" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "qrCode-page", attrs: { id: "qrCodePrint" } },
            _vm._l(_vm.barcodeList, function (item) {
              return _c(
                "div",
                _vm._l(_vm.printCount, function (index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "bracodeheader" },
                    [
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "15" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "bracodeheader-count",
                                  style: {
                                    "font-size": "13px",
                                    "margin-bottom": !item.idCard ? "5px" : "",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "12px" } },
                                    [_vm._v(_vm._s(item.name ? item.name : ""))]
                                  ),
                                  _vm._v(" \n                  "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.gender === 1
                                          ? "男"
                                          : item.gender === 2
                                          ? "女"
                                          : ""
                                      )
                                    ),
                                  ]),
                                  _vm._v(" \n                  "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(item.age ? item.age + "岁" : "")
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "bracodeheader-idCard",
                                  style: {
                                    "font-size": "14px",
                                    "margin-top": item.idCard ? "-3px" : "",
                                  },
                                },
                                [_vm._v(_vm._s(item.idCard ? item.idCard : ""))]
                              ),
                              !item.barCodeImage
                                ? _c(
                                    "barcode",
                                    {
                                      attrs: {
                                        value: item.barCode,
                                        height: "60",
                                        width: "2",
                                        displayValue: "false",
                                        marginTop: "-5",
                                        marginLeft: "20",
                                        "margin-right": "40",
                                      },
                                    },
                                    [_vm._v("条形码加载失败")]
                                  )
                                : _vm._e(),
                              item.barCodeImage
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-top": "-8px",
                                        "margin-left": "15px",
                                        width: "115px",
                                        height: "35px",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                        },
                                        attrs: { src: item.barCodeImage },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("Col", { attrs: { span: "2" } }),
                          _c(
                            "Col",
                            { attrs: { span: "7" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "bracodeheader-count",
                                  staticStyle: {
                                    "font-size": "12px",
                                    "margin-left": "0px",
                                    "margin-right": "2px",
                                  },
                                },
                                [_vm._v("抽血试管")]
                              ),
                              _vm._l(
                                item.testTubes.split("、"),
                                function (testTube) {
                                  return item.testTubes
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "bracodeheader-count",
                                          staticStyle: {
                                            "font-size": "12px",
                                            "margin-left": "0px",
                                            "margin-top": "0px",
                                            "word-break": "break-all",
                                            "line-height": "15px",
                                            "text-align": "left",
                                            width: "100%",
                                          },
                                        },
                                        [_vm._v(_vm._s(testTube))]
                                      )
                                    : _vm._e()
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          style: {
                            position: "relative",
                            "font-size": "15px",
                            float: "left",
                            "padding-left": "20px",
                            "margin-top": "-3px",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(item.barCode ? item.barCode : "") +
                              _vm._s(item.serNum ? "    " + item.serNum : "")
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "bracodeheader-class",
                          staticStyle: { "font-size": "12px" },
                        },
                        [
                          _vm._v(
                            _vm._s(item.gradeName ? item.gradeName : "") +
                              "    " +
                              _vm._s(item.className ? item.className : "")
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "a",
        {
          directives: [
            {
              name: "print",
              rawName: "v-print",
              value: _vm.printQrCodeContent,
              expression: "printQrCodeContent",
            },
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          attrs: { id: "printBarcode" },
        },
        [_vm._v("打印")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }